<template>
  <DeletePopover @delete="$emit('delete')">
    <i class="el-icon-error icon-button delete-icon-button"></i>
  </DeletePopover>
</template>

<script>
import DeletePopover from "@/components/DeletePopover";
export default {
  name: "DeleteIconButton",
  components: {
    DeletePopover
  }
};
</script>
